export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f6b8e78effde3e3acf3720112ef5fa8c59ac98815&name=fetchTypeahead!'